import * as Labels_en from './Labels.en.js';
import * as Labels_es from './Labels.es.js';

const LabelsTuple = [
  { type: 'Labels', language: 'en', object: Labels_en.default },
  { type: 'Labels', language: 'es', object: Labels_es.default },
];

export default LabelsTuple;
